var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-variables"},_vm._l((_vm.options),function(item,index){return _c('div',{key:index,staticClass:"editor-variables__item",on:{"click":function($event){return _vm.$emit('select', item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }